export default __webpack_public_path__ + "static/media/lg-h.38395f79.jpg";